
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { storeReferralCodeInCookie, storeAffiliateIdInCookie } from "./referralUtils";

export const useReferralUrlParams = () => {
  const location = useLocation();

  // Check URL for referral code and affiliate ID and store in cookies if found
  useEffect(() => {
    try {
      const searchParams = new URLSearchParams(location.search);
      
      // Handle referral code
      const urlReferralCode = searchParams.get("referralCode");
      if (urlReferralCode) {
        console.log("Found referral code in URL:", urlReferralCode);
        storeReferralCodeInCookie(urlReferralCode);
      }
      
      // Handle affiliate ID (click_id) - check both possible parameter names
      const urlAffiliateId = searchParams.get("click_id") || searchParams.get("affid");
      if (urlAffiliateId) {
        console.log("Found affiliate ID in URL:", urlAffiliateId);
        storeAffiliateIdInCookie(urlAffiliateId);
      }
    } catch (error) {
      console.error("Error processing URL parameters:", error);
    }
  }, [location.search]);
};
